import { render, staticRenderFns } from "./ToolsBrand.vue?vue&type=template&id=6c047a4a&"
import script from "./ToolsBrand.vue?vue&type=script&lang=js&"
export * from "./ToolsBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports